module.exports = __webpack_public_path__ + "static/media/m_faceshape_round_vector.d0952dc9.svg";